import useSWR from "swr";

import { fetcher } from "@/lib/fetcher";

export type MarketingPermissions = {
  canSchedule: boolean;
  canPublishNow: boolean;
  canEditAssets: boolean;
  canManageCampaigns: boolean;
  canUseAutomation: boolean;
  platform: {
    instagram: boolean;
    tiktok: boolean;
    facebook: boolean;
    youtube: boolean;
  };
};

export const DEFAULT_MARKETING_PERMISSIONS: MarketingPermissions = {
  canSchedule: false,
  canPublishNow: false,
  canEditAssets: false,
  canManageCampaigns: false,
  canUseAutomation: false,
  platform: {
    instagram: false,
    tiktok: false,
    facebook: false,
    youtube: false,
  },
};

export function usePermissions() {
  const { data, error, isLoading } = useSWR<MarketingPermissions>(
    "/auth/permissions/marketing",
    fetcher,
    {
      revalidateOnFocus: false,
      fallbackData: DEFAULT_MARKETING_PERMISSIONS,
    },
  );
  return {
    permissions: data ?? DEFAULT_MARKETING_PERMISSIONS,
    error,
    isLoading,
  };
}
